// routes/DepartmentRoutes.js - Updated
import React from 'react';
import { Route, Routes } from 'react-router-dom';
import MainDepartmentPage from '../components/pages/MainDepartmentPage';
import AgencyPage from '../components/pages/AgencyPage';
import { getAllDepartmentIds } from '../utils/departmentConfig';

const DepartmentRoutes = () => {
  const departmentIds = getAllDepartmentIds();
  
  return (
    <Routes>
      {departmentIds.map(departmentId => (
        <React.Fragment key={departmentId}>
          <Route
            path={departmentId}
            element={<MainDepartmentPage department={departmentId} />}
          />
          <Route
            path={`${departmentId}/:agencyId`}
            element={<AgencyPage />}
          />
        </React.Fragment>
      ))}
      
      <Route 
        path="*" 
        element={
          <div style={{ 
            padding: '20px', 
            color: 'var(--text-primary)', 
            textAlign: 'center',
            backgroundColor: 'var(--bg-primary)'
          }}>
            <h3 style={{ color: 'var(--text-primary)' }}>Page Not Found</h3>
            <p style={{ color: 'var(--text-secondary)' }}>The requested page could not be found.</p>
          </div>
        } 
      />
    </Routes>
  );
};

export default DepartmentRoutes;